import { render } from "./MonitorOff.vue?vue&type=template&id=1ccf39a5"
import script from "./MonitorOff.vue?vue&type=script&lang=js"
export * from "./MonitorOff.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__